export default "__VITE_PUBLIC_ASSET__8b4bad9f__"